/**
* @author ZhanFuzheng
* @date 2022/07/18
* @time 16:13
*/
<template>
    <div class="wrapper">
        <!--头部-->
        <div class="header">
            <div class="header-left" @click="goBack"><img src="@/assets/vip/icon_back1.png" alt="" /></div>
            <div class="header-main">扫描结果</div>
            <div class="header-right"></div>
        </div>
        <div class="wrapper-body">
            <h4>扫码内容<span>非斑斑驾道</span>提供请谨慎使用</h4>
            <div class="content">{{scanData}}</div>
            <p>如需使用，可通过复制获取内容</p>
        </div>
    </div>
</template>

<script>
export default {
    name: 'scanResult',
    data () {
        return {
            scanData: ''
        }
    },
    methods: {
        // 返回
        goBack () {
            this.$jsBridge.callBackHandler('returnLastPage')
        },
        // 获取扫描的结果信息
        getScanResult () {
            this.scanData = this.$jsBridge.callBackHandler('passBarcodeData')
        }
    },
    mounted () {
        this.getScanResult()
    }
}
</script>

<style lang="scss">
    .wrapper {
        display: flex;
        flex-direction: column;
        background: #fff;
        .header {
            display: flex;
            align-items: center;
            justify-content: space-between;
            height: 44px;
            background: #ffffff;
            .header-main {
                font-size: 18px;
                font-family: PingFangSC;
                font-weight: bold;
                color: #333333;
            }
            .header-share {
                position: absolute;
                height: 44px;
                display: flex;
                align-items: center;
                right: 20px;
                font-size: 0;
                line-height: 1;
                img {
                    width: 24px;
                }
            }
            .header-left, .header-right {
                display: flex;
                padding: 15px 10px;
                width: 24px;
                height: 24px;
                font-size: 0;
                line-height: 1;
                img {
                    width: 24px;
                    height: 24px;
                }
            }
        }
        &-body{
            flex: 1;
            display: flex;
            flex-direction: column;
            align-items: center;
            padding: 64px 0;
            h4{
                color:#333;
                text-align: center;
                font-size: 18px;
                width: 228px;
                line-height: 32px;
                span{
                    font-size: 24px;
                }
            }
            .content{
                width: 228px;
                margin-top: 16px;
                color:#333;
                font-size: 15px;
                line-height: 21px;
                word-break: break-all;
                font-weight: 600;
                font-family: PingFangSC-Semibold, PingFang SC;
            }
            p{
                margin-top: 22px;
                color: #999;
                font-size: 15px;
                font-weight: 400;
                font-family: PingFangSC-Regular, PingFang SC;
            }
        }
    }
</style>
